/**
 * @generated SignedSource<<df49200b59a3e6e48cac374a1f457dc4>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type BreadCrumbsHeader_query$data = {
  readonly UrlConfig: {
    readonly docs: string | null | undefined;
  } | null | undefined;
  readonly whoami: {
    readonly displayName: string | null | undefined;
    readonly email: string | null | undefined;
  };
  readonly " $fragmentType": "BreadCrumbsHeader_query";
};
export type BreadCrumbsHeader_query$key = {
  readonly " $data"?: BreadCrumbsHeader_query$data;
  readonly " $fragmentSpreads": FragmentRefs<"BreadCrumbsHeader_query">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "BreadCrumbsHeader_query",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "CurrentUser",
      "kind": "LinkedField",
      "name": "whoami",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "email",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "displayName",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "kind": "ClientExtension",
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "UrlConfig",
          "kind": "LinkedField",
          "name": "UrlConfig",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "docs",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "8ce7f934a73ede8ecc54b64ba9916fa0";

export default node;
